import data from "../../../../../src/StyledOcticon/StyledOcticon.docs.json";
import * as React from 'react';
export default {
  data,
  React
};